//#region Angular Imports

import { StateService } from '@uirouter/angularjs'

//#endregion

//#region DevExtreme Imports

import 'devextreme/ui/button'
import 'devextreme/ui/data_grid'
import 'devextreme/ui/list'
import 'devextreme/ui/load_indicator'
import 'devextreme/ui/popover'
import 'devextreme/ui/popup'
import 'devextreme/ui/scroll_view'
import 'devextreme/ui/tag_box'
import 'devextreme/ui/text_area'
import 'devextreme/ui/tooltip'

//#endregion

import { Api, LocalDictionaryFactory } from '../../api/api.module'
import { GridController } from './grid.controller'

//#region Services

import { DATE_BOX_CONTROLS_SERVICE_NAME, DateBoxControlsService } from '../../../services/controls'
import { DATA_TYPE_FORMAT_SERVICE_NAME, DataTypeFormatService } from '../../../services/data-type'
import { USER_SESSION_SERVICE_NAME, UserSessionService } from '../../../services/user-session'
import { $STATE_SERVICE_NAME, $Q_SERVICE_NAME, $TIMEOUT_SERVICE_NAME, $SCOPE_SERVICE_NAME, $COMPILE_SERVICE_NAME } from '../../../services/system'

//#endregion

//#region Asset Imports

import './grid.scss'
import * as TEMPLATE from './grid.tpl.html'

//#endregion

export class GridDirective implements ng.IDirective {
    restrict = 'E'

    scope = {
        options: '=',
        isNarrowGrid: '='
    }

    controller = [
        $SCOPE_SERVICE_NAME,
        $TIMEOUT_SERVICE_NAME,
        $STATE_SERVICE_NAME,
        'logger',
        $Q_SERVICE_NAME,
        'localDictionary',
        'api',
        $COMPILE_SERVICE_NAME,
        USER_SESSION_SERVICE_NAME,
        DATA_TYPE_FORMAT_SERVICE_NAME,
        DATE_BOX_CONTROLS_SERVICE_NAME,
        (
            $scope,
            $timeout: ng.ITimeoutService,
            $state: StateService,
            logger,
            $q: ng.IQService,
            localDictionary: LocalDictionaryFactory,
            api: Api,
            $compile: ng.ICompileService,
            userSession: UserSessionService,
            dataFormatService: DataTypeFormatService,
            dateBoxControlsService: DateBoxControlsService
        ) => {
            return new GridController(
                $scope,
                $timeout,
                $state,
                logger,
                $q,
                localDictionary,
                api,
                $compile,
                userSession,
                dataFormatService,
                dateBoxControlsService
            )
        }]

    template = TEMPLATE
    replace = true
    transclude = true
}